<script>
import { GlLink } from '@gitlab/ui';
import MaybachLogo from './logo.vue';

export default {
  name: 'MaybachHead',
  components: {
    GlLink,
    MaybachLogo,
  },
};
</script>

<template>
  <header>
    <nav
      class="header navbar gl-h-8 gl-z-index-2 gl-display-flex gl-justify-content-space-between gl-fixed gl-px-5 gl-mb-0 gl-border-b-solid gl-border-b-1 gl-border-gray-200 gl-top-0 gl-left-0 gl-right-0"
      style="background-color: #1e40af"
      data-qa-selector="navbar"
    >
      <maybach-logo />
      <div class="gl-display-inline-flex gl-align-items-center">
        <gl-link
          class="gl-p-3 gl-transition-slow gl-text-decoration-none! gl-font-weight-bold theme-indigo-200"
          href="https://maybachsystems.com/contact"
        >
          Contact support
        </gl-link>
      </div>
    </nav>
  </header>
</template>
